import { GetDefaultIndexWithCollect } from "../../components";
import {
  useGetAnnouncementCommonInfoQuery,
  useCollectAnnouncementsMutation,
} from "../../features/api/announcementApi";
import { useAnnouncementRoutes } from "./routes";
import { AnnouncementCollector } from "./announceCollector";

export { useAnnouncementRoutes };

export default GetDefaultIndexWithCollect({
  title: "اطلاعیه‌ها",
  query: useGetAnnouncementCommonInfoQuery,
  collectMutation: useCollectAnnouncementsMutation,
  collector: (collectCallback) => <AnnouncementCollector collectCallback={collectCallback} />,
});
